import {z} from "zod";
import {BasePlatformObject} from "../../../schemas";

// Mirrors `type ProviderMapping` in flexinet-billing-api
// src/appsync-api/src/schema/features/provider-mappings.graphql. Nullable there means
// .nullish() here: a row may come back with null, not just a missing key.

const BillingProviderSchema = z.object({
    id: z.string(),
    name: z.string(),
    description: z.string().nullish()
});

const CreatedByUserSchema = z.object({
    username: z.string(),
    givenName: z.string().nullish(),
    familyName: z.string().nullish()
});

// enum ProviderEntityType: all seven. Dev holds PaymentEvent, Invoice and InvoiceItem
// rows written by the provider sync, not only the three the Add form creates.
export const ProviderEntityTypeSchema = z.enum([
    'Customer',
    'Product',
    'Price',
    'Subscription',
    'Invoice',
    'InvoiceItem',
    'PaymentEvent',
]);

// enum SyncStatus
export const SyncStatusSchema = z.enum([
    'Synced',
    'Pending',
    'Failed',
    'Conflict',
]);

export const ProviderMappingSchema = BasePlatformObject.extend({
    entityType: ProviderEntityTypeSchema,
    localEntityId: z.string().min(1, "Local entity ID is required"),
    billingProviderId: z.string().min(1, "Billing provider ID is required"),
    billingProvider: BillingProviderSchema.nullish(),
    providerEntityId: z.string(),
    syncStatus: SyncStatusSchema,
    providerSpecificData: z.unknown().nullish(),
    lastSyncAt: z.string().nullish(),
    syncError: z.string().nullish(),
    updated: z.string().nullish(),
    createdByUser: CreatedByUserSchema.nullish()
});
